import React, { useEffect } from "react";

interface AddressBoxRequiredModalProps {
  open: boolean;
  onClose: () => void;
  onAddAddressBox: () => void;
}

export const AddressBoxRequiredModal: React.FC<AddressBoxRequiredModalProps> = ({ open, onClose, onAddAddressBox }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[1300] flex items-center justify-center"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onMouseDown={onClose}
      data-cypress-id="designGalleryAddressBoxModal"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="address-box-required-title"
        className="w-[420px] max-w-[90vw] rounded-xl bg-card p-6 shadow-[0px_10px_30px_rgba(2,6,23,0.18)]"
        onMouseDown={(event) => event.stopPropagation()}
        data-cypress-id="designGalleryAddressBoxModalContentWrapper"
      >
        <div data-cypress-id="designGalleryAddressBoxModalContent">
          <h2
            id="address-box-required-title"
            className="text-base font-semibold text-foreground"
            data-cypress-id="designGalleryAddressBoxModalTitle"
          >
            Address box required
          </h2>
          <p
            className="text-muted-foreground mt-2 text-sm leading-5"
            data-cypress-id="designGalleryAddressBoxModalBody"
          >
            The selected design does not have an address box. An address box is required for Direct Mail campaigns. You
            can add one now or choose a different design.
          </p>
        </div>
        <div
          className="mt-6 flex items-center justify-end gap-3"
          data-cypress-id="designGalleryAddressBoxModalButtonContainer"
        >
          <button
            type="button"
            onClick={onClose}
            data-cy="admDesignAddressBoxChooseAnotherButton"
            data-cypress-id="designGalleryAddressBoxModalSecondaryButton"
            className="text-foreground border-border h-9 rounded-lg border border-solid bg-background px-4 text-sm font-medium"
          >
            Choose Another Design
          </button>
          <button
            type="button"
            onClick={onAddAddressBox}
            data-cy="admDesignAddAddressBoxButton"
            data-cypress-id="designGalleryAddressBoxModalPrimaryButton"
            className="h-9 rounded-lg bg-primary px-4 text-sm font-medium text-primary-foreground"
          >
            Add Address Box
          </button>
        </div>
      </div>
    </div>
  );
};
